import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoZte = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 56 24",
	style: { enableBackground: "new 0 0 56 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E2001A;}\n	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\n	.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FEFEFE;}\n"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		transform: "translate(0.248459, 0.000000)",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				id: "Fill-1",
				className: "st0",
				points: "-0.2,24 17.6,24 17.6,0 -0.2,0  "
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M18.8,24h17.9V0H18.8V24z M37.9,24h17.9V0H37.9V24z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st2",
				d: "M4.5,3.9h9v3.2L7.8,17.3h5.8v2.9H3.8V17L9.4,6.8H4.5V3.9z M22.5,3.9H33v2.8h-3.2v13.4h-4V6.8h-3.2L22.5,3.9 L22.5,3.9z M51,3.9v2.9h-4.5v3.7h4.2v2.9h-4.2v3.9H51v2.9h-8.4V3.9H51z"
			})
		]
	})]
});
export default SvgLogoZte;
